<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{ $t('Contrat.s') }}</h1>
          <template v-if="totalCount === 0 || totalCount === 1">
            <h2 class="page-subtitle">{{ totalCount }} {{ $t('contrat') }}</h2>
          </template>
          <template v-else>
            <h2 class="page-subtitle">{{ totalCount }} {{ $t('contrat.s') }}</h2>
          </template>
        </div>
        <b-button class="btn-medium" variant="primary" @click="clickOnCreateBtn">
          <plus-icon class="mr-1" size="18"/>
          {{ $t('Add') }} {{ $t('a') }} {{ $t('contrat') }}
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableInvestorContrat"
          :delete-item="isEstateAgent"
          :edit-item="isEstateAgent"
          :empty-button="$t('contrat.emptyButton').toString()"
          :empty-text="$t('contrat.emptyText').toString()"
          :empty-title="$t('contrat.emptyTitle').toString()"
          :fields="tableFields"
          get-b122-table-results-url="/investorContrat/getB122TableResults"
          identifier="B122TableInvestorContrat"
          init-b122-table-url="/investorContrat/initB122Table"
          @add="clickOnCreateBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnShowBtn="clickOnShowBtn"
          @setTotalCount="setTotalCount">

          <template v-slot:cell(bilanType)="data">
            <div v-if="data.item.idAvp && data.item.idExe">
              <div>AVP</div>
              <div>EXE</div>
            </div>
            <div v-else-if="data.item.idAvp">AVP</div>
            <div v-else-if="data.item.idExe">EXE</div>
          </template>

          <template v-slot:cell(initialPayment)="data">
            <div v-if="data.item.idAvp && data.item.idExe">
              <div>{{ formatCurrency(data.item.avp.initialPayment) }}</div>
              <div>{{ formatCurrency(data.item.exe.initialPayment) }}</div>
            </div>
            <div v-else-if="data.item.idAvp">
              {{ formatCurrency(data.item.avp.initialPayment) }}
            </div>
            <div v-else-if="data.item.idExe">
              {{ formatCurrency(data.item.exe.initialPayment) }}
            </div>
          </template>

          <template v-slot:cell(datePayment)="data">
            <div v-if="data.item.idAvp && data.item.idExe">
              <div>{{ formatDate(data.item.avp.datePayment) }}</div>
              <div>{{ formatDate(data.item.exe.datePayment) }}</div>
            </div>
            <div v-else-if="data.item.idAvp">
              {{ formatDate(data.item.avp.datePayment) }}
            </div>
            <div v-else-if="data.item.idExe">
              {{ formatDate(data.item.exe.datePayment) }}
            </div>
          </template>

          <template v-slot:cell(rendement)="data">
            <div v-if="data.item.idAvp && data.item.idExe">
              <div>{{ data.item.avp.rendement }} %</div>
              <div>{{ data.item.exe.rendement }} %</div>
            </div>
            <div v-else-if="data.item.idAvp">
              {{ data.item.avp.rendement }} %
            </div>
            <div v-else-if="data.item.idExe">
              {{ data.item.exe.rendement }} %
            </div>
          </template>

          <template v-slot:cell(deadline)="data">
            <div v-if="data.item.idAvp && data.item.idExe">
              <div>{{ formatDate(data.item.avp.deadline) }}</div>
              <div>{{ formatDate(data.item.exe.deadline) }}</div>
            </div>
            <div v-else-if="data.item.idAvp">
              {{ formatDate(data.item.avp.deadline) }}
            </div>
            <div v-else-if="data.item.idExe">
              {{ formatDate(data.item.exe.deadline) }}
            </div>
          </template>

          <template v-slot:cell(interests)="data">
            <div v-if="data.item.idAvp && data.item.idExe">
              <div>{{ formatCurrency(data.item.avp.interests) }}</div>
              <div>{{ formatCurrency(data.item.exe.interests) }}</div>
            </div>
            <div v-else-if="data.item.idAvp">
              {{ formatCurrency(data.item.avp.interests) }}
            </div>
            <div v-else-if="data.item.idExe">
              {{ formatCurrency(data.item.exe.interests) }}
            </div>
          </template>


        </b122-table>
      </b-card>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="false"
      :isFeminine="false"
      :selectedItemSpecialString="`'${selectedContrat ? selectedContrat.toStringWithBilan : null}'`"
      :selectedItem="selectedContrat"
      controllerName="investorContrat"
      itemSingularName="contrat"
      itemSingularNameUpp="Contrat"
      @didDeleteItem="didDeleteContrat()">
    </Item-delete-modal>

    <Investor-contrat-choose-modal
      :selectedItem="selectedContrat"
      id="choose-contrat-modal-edit"
      mode="edit">
    </Investor-contrat-choose-modal>

    <Investor-contrat-choose-modal
      :selectedItem="selectedContrat"
      id="choose-contrat-modal-delete"
      mode="delete"
      @chooseDelete="confirmDelete">
    </Investor-contrat-choose-modal>
  </div>
</template>

<script>
import B122Table from "../../../components/b122/B122Table";
import ItemDeleteModal from "../../../components/b122/ItemDeleteModal";
import InvestorContratChooseModal from "../components/InvestorContratChooseModal";
import api from "../../../services/api";

export default {
  name: "InvestorContratIndex",

  components: {
    B122Table,
    ItemDeleteModal,
    InvestorContratChooseModal
  },

  data() {
    return {
      totalCount: 0,
      totalValue: 0,
      username: this.$store.getters.username,
      isEstateAgent: this.$store.getters.isEstateAgent,
      selectedContrat: null
    }
  },

  computed: {
    tableFields() {
      return [
        { label: this.$t('See'), key: 'show', sortable: false },
        { label: this.$t('contrat.Name'), key: 'name', sortable: true },
        { label: this.$t('Bilan'), key: 'bilanType', sortable: false },
        { label: this.$t('contrat.capital'), key: 'initialPayment', sortable: true },
        { label: this.$t('contrat.date'), key: 'datePayment', sortable: true },
        { label: this.$t('contrat.rendement'), key: 'rendement', sortable: true },
        { label: this.$t('contrat.interests'), key: 'interests', sortable: false },
        { label: this.$t('contrat.deadline'), key: 'deadline', sortable: true },
        { label: '', key: 'actions' }
      ]
    }
  },

  methods: {
    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'InvestorShow',
        params: {
          investorContratId: row.item.groupId
        }
      })
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'InvestorContratCreateEdit',
        params: {
          investorContratId: null
        }
      })
    },

    clickOnEditBtn(row) {
      console.log(row)
      this.selectedContrat = row.item
      if (row.item.idAvp && row.item.idExe) {
        this.$bvModal.show('choose-contrat-modal-edit')
      } else {
        this.$router.push({
          name: 'InvestorContratCreateEdit',
          params: { investorContratId: row.item.idAvp || row.item.idExe }
        })
      }
    },

    clickOnDeleteBtn(row) {
      this.selectedContrat = row.item
      if (row.item.idAvp && row.item.idExe) {
        this.$bvModal.show('choose-contrat-modal-delete')
      } else {
        this.confirmDelete(row.item.idAvp || row.item.idExe)
      }
    },

    async confirmDelete(id) {
      await this.fetchContrat(id)
      this.$bvModal.show('item-delete-modal')
    },

    async fetchContrat(id) {
      await api
        .get(`/investorContrat/${id}`)
        .then(response => {
          this.selectedContrat = response.data
        })
    },

    didDeleteContrat() {
      this.selectedContrat = null
      this.$refs.B122TableInvestorContrat.refreshTable()
    },

    formatCurrency(value) {
      if (!value && value !== 0) return ''
      return Intl.NumberFormat().format((value / 100).toFixed(2)) + ' €'
    },

    formatDate(value) {
      if (!value) return ''
      const d = new Date(value)
      return isNaN(d.getTime()) ? '' : d.toLocaleDateString()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/investor/investorContrat/InvestorContratIndex.vue